import axios from "../../helpers/httpClient";

export default {
    dataForm: async ({ commit, state }) => {

    },
    badRegisterFront: async ({ commit, state }) => {
        const success = "error"
        const message = "error"

        commit('SET_STATE_LOGIN', { success: success, message: message })
    },
    register: async ({ commit, state, dispatch }, data) => {

        try {

            // Start loader
            commit('SET_LOADER', true);

            let response = await axios.post(`/information/create`, data)

            // Stop Loader
            commit('SET_LOADER', false);

            if (response.status === 200) {

                dispatch('activeMessageCorrect', response.data.message)

                const success = response.data.message === "Usuario creado" ? "ok" : "error"
                const message = response.data.message

                commit('SET_STATE_LOGIN', { success: success, message: message })

                return 'ok'
            }

        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }

    },
    login: async ({ state, dispatch, commit }, user) => {

        try {
            // Start loader
            commit('SET_LOADER', true);

            const response = await axios.post(`/login`, {
                email: user.email,
                password: user.password
            })

            // Stop Loader
            commit('SET_LOADER', false);

            if (response.status === 200) {
                //guardar token
                localStorage.setItem('token', response.data.token ? response.data.token : response.data.message)

                //notificacion al usuario
                dispatch('activeMessageCorrect', 'Inicio de sesión exitoso')
                return 'ok'
            }
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },
    loginWithGoogle: async ({ commit, state, dispatch }, func) => {
        try {
            //datos del inicio de sesion
            const googleUser = await func()
            // Start loader
            commit('SET_LOADER', true);

            let respuesta = await axios.post(`/login/google`, {
                tokengoogle: googleUser.access_token
            })

            if (respuesta.status === 200) {
                 // Stop Loader
                commit('SET_LOADER', false);

                return respuesta.data.token
            }
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },
    checkLoginWithGoogle: async ({ state, dispatch, commit }, message) => {
        try {
            // Start loader
            commit('SET_LOADER', true);

            //confirmacion de token con api
            await axios.post(`/information/confirmarGoogle`, {
                token: message
                //pensar en posibilidad de que token quede como estado global
            })

            // Stop Loader
            commit('SET_LOADER', false);
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },
    recover: async ({ commit, state, dispatch }, data) => {

        try {
            // Start loader
            commit('SET_LOADER', true);

            const response = await axios.post(`/email/recuperar`, {
                email: data.email,
                email2: data.email2
            })

            // Stop Loader
            commit('SET_LOADER', false);

            if (response.status === 200) {

                const success = "ok"
                const message = ""

                //notificacion al usuario
                dispatch('activeMessageCorrect', 'Envío exitoso')

                commit('SET_STATE_LOGIN', { success: success, message: message })

                return 'ok'
            }
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },
    recoverSucces: async ({ commit, state, dispatch }, data) => {
        try {
            // Start loader
            commit('SET_LOADER', true);

            let mensaje = await axios.put(`/information/updatepassword`, {
                Password: data.password,
                token: data.id
            })

            if(mensaje.status === 200){
                // Stop Loader
                commit('SET_LOADER', false);

                return 'ok'
            }
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }

    },
    // if(this.stateLogin.message === "Error en validación"){
    //     this.$router.push({path: '/login'})
    // }
    confirmEmail: async ({ commit, state, dispatch }, cod) => {
        const stateData = state.headerProfile
        try {
            // Start loader
            commit('SET_LOADER', true);

            let mensaje = await axios.post(`/information/private/verificacionCodigoCorreo`, {
                codigo: cod
            });

            // Stop Loader
            commit('SET_LOADER', false);

            if (mensaje.status === 200) {

                dispatch('activeMessageCorrect', 'Correo Verificado')
                commit('SET_HEADER_PROFILE', {...stateData, Confirmacion_correo: true});
                return 'ok'
            }
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },
    clearStateLogin: async ({ commit, state }) => {
        commit('SET_STATE_LOGIN', { success: "", message: "" })
    },
    sesionActive: async ({ commit, state }) => {
        commit('SET_SESION_ACTIVE', true)
    },
    sesionInactive: async ({ commit, state }) => {
        commit('SET_SESION_ACTIVE', false)
    },
    sendNotificationVerificationCode: async ({ state, dispatch, commit }) => {
        try {
            // Start loader
            commit('SET_LOADER', true);

            let mensaje = await axios.post(`/email/verficarCorreo`, {
                token: localStorage.getItem('token'),
            });

            // Stop Loader
            commit('SET_LOADER', false);

            if (mensaje.status === 200) {
                //notificacion al usuario
                dispatch('activeMessageCorrect', 'Correo enviado')
                return 'ok'
            }
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    }
}